import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import Typography from '.';
/**
 * Forwards ref to the component
 *
 * @param variant - Variant of the typography component
 * @param weight - Weight of the typography component
 * @returns Returns the original component with a forwarded ref
 */
const fwdref = function (variant, weight, as) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    return /*#__PURE__*/React.createElement(Typography, _extends({
      ref: ref,
      variant: variant,
      weight: weight,
      as: as
    }, props));
  });
};

/** DISPLAY TYPOGRAPHY PRESETS */

/**
 * Display 01 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const D1 = fwdref('display-1');

/**
 * Display 01 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const D2 = fwdref('display-2');

/**
 * Display 01 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const D3 = fwdref('display-3');

/**
 * Display 01 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const D4 = fwdref('display-4');

/** HEADLINE TYPOGRAPHY PRESETS */

/**
 * Headline 1 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H1 = fwdref('headline-1');

/**
 * Headline 2 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H2 = fwdref('headline-2');

/**
 * Headline 3 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H3 = fwdref('headline-3');

/**
 * Headline 4 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H4 = fwdref('headline-4');

/**
 * Headline 5 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H5 = fwdref('headline-5');

/**
 * Headline 6 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const H6 = fwdref('headline-6');

/** BODY TYPOGRAPHY PRESETS */

/**
 * Body 01 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const B1 = fwdref('body-1');

/**
 * Body 02 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const B2 = fwdref('body-2');

/**
 * Body 03 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const B3 = fwdref('body-3');

/**
 * Body 04 preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const B4 = fwdref('body-4');

/** FONT WEIGHT PRESETS */

/**
 * Thin Preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Thin = fwdref('inherit', 'thin');

/**
 * Regular Preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Regular = fwdref('inherit', 'regular');

/**
 * Medium Preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Medium = fwdref('inherit', 'medium', 'strong');

/**
 * Demi Preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Demi = fwdref('inherit', 'demi', 'strong');

/**
 * Bold Preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Bold = fwdref('inherit', 'bold', 'strong');

/**
 * Heavy Preset
 *
 * @version PACKAGE_VERSION
 * @tutorial http://in/ids-storybook
 */
export const Heavy = fwdref('inherit', 'heavy', 'strong');
//# sourceMappingURL=Typography.presets.js.map